/** YouTube or Vimeo *embed* URL for Tebogo's welcome video. Leave empty until the video exists. */
export const INTRO_VIDEO_EMBED_URL = "";

/**
 * Stored with each registration so we know which wording the attendee accepted: the date Kole
 * Medical approved it. In production the server records its own value (the PRIVACY_NOTICE_VERSION
 * secret, or the default in supabase/functions/_shared/config.ts): change them together.
 */
export const PRIVACY_NOTICE_VERSION = "2026-10-15";

export const ROLES = [
  "Healthcare professional",
  "Medical device business / distributor",
  "Manufacturer / supplier",
  "Student / aspiring entrepreneur",
  "Other",
];

// ══════════════════════════════════════════════════════════════════════════════
//   BACKEND — set in .env (see docs/WEBINARS-PRODUCTION.md), read when the site is built
//     REACT_APP_WEBINAR_BACKEND=supabase
//     REACT_APP_SUPABASE_URL=https://<project>.supabase.co
//     REACT_APP_SUPABASE_PUBLISHABLE_KEY=<publishable or anon key — public by design>
//   Anything else runs the prototype, which keeps data in this browser only.
//   Never put the service-role or secret key here: everything in .env ships to browsers.
// ══════════════════════════════════════════════════════════════════════════════

export type Backend = "prototype" | "supabase";

export const WEBINAR_BACKEND: Backend = process.env.REACT_APP_WEBINAR_BACKEND === "supabase" ? "supabase" : "prototype";

export const IS_PROTOTYPE = WEBINAR_BACKEND === "prototype";

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL ?? "";

export const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ?? process.env.REACT_APP_SUPABASE_ANON_KEY ?? "";

/**
 * Prototype only: the simulated email limits, the same as Resend's free plan: 100 a day (reset at
 * 00:00 UTC = 02:00 SAST) and 3,000 a calendar month. In production the database holds the limits
 * (public.email_quota_settings).
 */
export const PROTOTYPE_DAILY_EMAIL_LIMIT = 100;
export const PROTOTYPE_MONTHLY_EMAIL_LIMIT = 3000;

/**
 * Supabase's usage page for the Kole Medical organisation, where egress and log figures are read.
 * Not secret: it only opens for people signed in to that Supabase organisation.
 */
export const SUPABASE_USAGE_URL = "https://supabase.com/dashboard/org/fzfgdobrkplgsftwebnn/usage";

/** Registration enquiries, shown on the confirmation page and in emails */
export const REGISTRATION_CONTACT = {
  email: "info@kolemedical.co.za",
  phone: "+27 64 540 6751",
};
